module.exports = __webpack_public_path__ + "media/img/virtual-internships/company-testimonial-moripesh-a24018309e86156aee64146bd5807023.png";